import type { StartPeriod } from '../db/models'

/*
  Die Wörter für eine **Tageszeit** (Vormittag, Mittag, Nachmittag, Abend), Deutsch und Englisch.
  Hier und nicht mehr im Datumsfeld: Seit #234 liest auch die Erkennung im Titel sie.
*/

/** Period keywords mapped to StartPeriod (German + English) */
export const PERIOD_KEYWORDS: Record<string, StartPeriod> = {
  // German
  vormittag: 'morning',
  vormittags: 'morning',
  mittag: 'noon',
  mittags: 'noon',
  nachmittag: 'afternoon',
  nachmittags: 'afternoon',
  abend: 'evening',
  abends: 'evening',
  // English
  morning: 'morning',
  noon: 'noon',
  afternoon: 'afternoon',
  evening: 'evening',
}

// Compile each keyword's word-boundary regex once at module scope —
// extractPeriod runs in a hot path on every task-input keystroke.
const PERIOD_KEYWORD_REGEXES: Array<{ regex: RegExp; period: StartPeriod }> =
  Object.entries(PERIOD_KEYWORDS).map(([keyword, period]) => ({
    regex: new RegExp(`\\b${keyword}\\b`, 'i'),
    period,
  }))

/**
 * Extract a period keyword from the input string.
 * Returns the matched period and the input with the keyword removed.
 */
export function extractPeriod(input: string): { period: StartPeriod | null; cleaned: string } {
  const lower = input.toLowerCase()
  for (const { regex, period } of PERIOD_KEYWORD_REGEXES) {
    if (regex.test(lower)) {
      return { period, cleaned: input.replace(regex, '').trim() }
    }
  }
  return { period: null, cleaned: input }
}
